'use client';

import React, { useCallback } from 'react';
import { Solicitud } from '@/types/solicitud';
import SolicitudManagement from './SolicitudManagement';
import { solicitudService } from '@/lib/api/solicitudService';
import { useAuth } from '@/hooks/useAuth';
import { Badge } from '@/components/ui/Badge';

const hasValue = (value?: string | null) => Boolean(value && String(value).trim() !== '');

const AutorizacionRiesgosManagement: React.FC = () => {
  const { user } = useAuth();
  const authSub = user?.sub ?? null;

  const customFetch = useCallback(
    async (setSolicitudes: (s: Solicitud[]) => void) => {
      if (!authSub) return;
      const response = await solicitudService.getAutorizacionRiesgos(authSub);
      setSolicitudes(response.data || []);
    },
    [authSub]
  );

  const getVoBoBadge = (fechaVoBo: string | undefined): 'success' | 'warning' => {
    return hasValue(fechaVoBo) ? 'success' : 'warning';
  };

  return (
    <SolicitudManagement
      title="Autorización Riesgos"
      customFetch={customFetch}
      modulo="autorizacion-riesgos"
      showNewButton={false}
      montoColumn="autorizado"
      renderActions={(s) => (
        <div className="flex items-center gap-2 flex-wrap">
          {s.fechaVoBo && (
            <Badge variant={getVoBoBadge(s.fechaVoBo)} className="text-xs">
              VoBo: {new Date(s.fechaVoBo).toLocaleDateString('es-MX', { day: '2-digit', month: '2-digit' })}
            </Badge>
          )}
        </div>
      )}
    />
  );
};

export default AutorizacionRiesgosManagement;
